import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createtext">
                1.&nbsp;<span className="material-symbols-outlined">format_size</span>&nbsp;{translate('createtext')}
            </Typography>
            <p><strong>{translate('createtext')}</strong> là một hành động tạo ra văn bản.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$text_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản bạn muốn tạo.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$text_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>The quick brown fox, jumps over the dog.</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>The quick brown fox, jumps over the dog.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="splittext">
                2.&nbsp;<span className="material-symbols-outlined">cut</span>&nbsp;{translate('splittext')}
            </Typography>
            <p><strong>{translate('splittext')}</strong> là một hành động phân tách văn bản bằng <strong>dấu phân cách</strong> thành một mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$splitText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản bạn muốn phân tách.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('splitwith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là dấu phân cách.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Phân tách văn bản bằng phẩy (,) thành 1 mảng.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$splitText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('splitwith')}</span>
                            <div>,</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "The quick brown fox"
                                            ," jumps over the dog."
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="replacetext">
                3.&nbsp;<span className="material-symbols-outlined">find_replace</span>&nbsp;{translate('replacetext')}
            </Typography>
            <p><strong>{translate('replacetext')}</strong> là một hành động thay thế một chuỗi trong văn bản bằng một chuỗi khác.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$replaceText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản bạn muốn thay thế.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('find')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là chuỗi tìm kiếm.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('replacewith')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là chuỗi thay thế.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Thay thế chuổi <strong>dog</strong> thành <strong>monkey</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$replaceText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('find')}</span>
                            <div>dog</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('replacewith')}</span>
                            <div>monkey</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>The quick brown fox, jumps over the monkey.</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="matchtext">
                4.&nbsp;<span className="material-symbols-outlined">search</span>&nbsp;{translate('matchtext')}
            </Typography>
            <p><strong>{translate('matchtext')}</strong> là một hành động tìm kiếm văn bản bằng một biểu thức chính quy và trả về các chuỗi phù hợp dưới dạng một mảng.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$splitText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là văn bản bạn muốn tìm kiếm.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('regexp')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là một biểu thức bằng chữ.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Tìm tất cả những chuỗi có chứa <strong>a</strong> dến <strong>z</strong>, <strong>A</strong> đến <strong>Z</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$splitText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('text')}</span>
                            <div>$text1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('find')}</span>
                            <div>([a-zA-Z])+</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "The",
                                            "quick",
                                            "brown",
                                            "fox",
                                            "jumps",
                                            "over",
                                            "the",
                                            "dog"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="readtext">
                5.&nbsp;<span className="material-symbols-outlined">description</span>&nbsp;{translate('readtext')}
            </Typography>
            <p><strong>{translate('readtext')}</strong> là một hành động đọc văn bản từ một tập tin.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$readText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tập tin txt.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tập tin text.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$readText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.txt</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertpdftotext">
                6.&nbsp;<span className="material-symbols-outlined">picture_as_pdf</span>&nbsp;{translate('convertpdftotext')}
            </Typography>
            <p><strong>{translate('convertpdftotext')}</strong> là một hành động chỉ trích xuất thông tin văn bản từ tệp PDF để nó có thể được xử lý dưới dạng một chuỗi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$pdfToText_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tập tin pdf.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$pdfToText_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.pdf</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="convertpdftotext">
                7.&nbsp;<span className="material-symbols-outlined">edit_document</span>&nbsp;{translate('appendvaluetotextfile')}
            </Typography>
            <p><strong>{translate('appendvaluetotextfile')}</strong> là hành động nối văn bản vào vị trí cụ thể trong tệp văn bản.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả của hành động này.</td>
                                <td>$textFile</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tập tin văn bản.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là giá trị nối thêm.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('position')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là vị trí để nối thêm văn bản. Chỉ định giá trị <strong>0</strong> để thêm vào đầu tệp <strong>end</strong> để thêm vào cuối tệp.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tệp văn bản.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$textFile</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file.txt</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>Wellcome to RPA CLOUD.</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('position')}</span>
                            <div>end</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>Hello world !!!Wellcome to RPA CLOUD.</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);